// extracted by mini-css-extract-plugin
export default {"part1":"part1_part1__2kAgV","left":"part1_left__NwhnX","right":"part1_right__wIW8N","date":"part1_date__yrsNU","flexbox":"part1_flexbox__74Kf9"};